import React from "react";
import { motion } from "framer-motion";
import broadcast from ".././Components/img/broadcast.jpg";
import banner from "../Components/banner/stv banner.jpg";

const STV = () => {
  const YouVid = [
    {
      vidlink: "https://www.youtube.com/embed/vJbtojVt2uY",
    },
    {
      vidlink: "https://www.youtube.com/embed/vJbtojVt2uY",
    },
    {
      vidlink: "https://www.youtube.com/embed/EGWbyyUGJOo",
    },
    {
      vidlink: "https://www.youtube.com/embed/HEFH9NEQTrw",
    },
    {
      vidlink: "https://www.youtube.com/embed/vJbtojVt2uY",
    },
    {
      vidlink: "https://www.youtube.com/embed/X9uIBqYwK0g",
    },
  ];

  const contentBlocks = [
    {
      title: "Broadcasting Truth",
      image: banner,
      imageAlt: "StarCross TV identity banner",
      overlayImage: "broadcast",
      overlayAlt: "Studio operations placeholder",
      paragraphs: [
        "Officially launched in April 2013, StarCross Television is the broadcast arm of the Brotherhood of the Cross and Star, created to communicate the reality of divine presence and kingdom establishment.",
        "Its programming is structured to inspire, enlighten, and spiritually strengthen audiences across cultures, backgrounds, and regions.",
      ],
    },
    {
      title: "Expanding Media Reach",
      image: broadcast,
      imageAlt: "StarCross broadcast platforms",
      overlayImage: "broadcast",
      overlayAlt: "Digital channels placeholder",
      paragraphs: [
        "Current distribution includes television, YouTube, Facebook, and official mobile app channels, allowing viewers to engage with content through multiple access points.",
        "This multi-platform strategy increases consistency, broadens reach, and keeps audiences connected to live and scheduled kingdom broadcasts.",
      ],
    },
    {
      title: "Curating Live Programming",
      image: broadcast,
      imageAlt: "Weekly program schedule placeholder",
      overlayImage: "broadcast",
      overlayAlt: "Broadcast packages placeholder",
      paragraphs: [
        "The station delivers a structured schedule of live and recorded programs, including Morning Star Breakfast Show, News Update, Spotlight, Forerunner, Prayer Line, and Regnum sessions.",
        "Specialized productions for celebrations, ceremonies, seminars, and service events further support the communication needs of the fold.",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          >
            <span className="h-[1px] w-10 bg-blue-500" />
            <span className="text-blue-600 font-bold text-[10px] tracking-[0.45em] uppercase">
              Brotherhood of the Cross and Star
            </span>
            <span className="h-[1px] w-10 bg-blue-500" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              StarCross{" "}
              <span className="text-blue-600 italic">Television.</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              Broadcasting truth, documenting kingdom life, <br /> and
              strengthening spiritual engagement through media.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
      <div className="flex items-center justify-center pt-40">
        <div className="grid sm:grid-cols-3 grid-cols-1 mt-10 gap-5 mb-10">
          {YouVid.map((item, index) => (
            <div>
              <iframe
                src={item.vidlink}
                title={`stv-video-${index + 1}`}
                className="w-fit h-64 self-center"
              />
            </div>
          ))}
        </div>
      </div>
    </motion.main>
  );
};

export default STV;
